import { render, staticRenderFns } from "./mailMessagingInput.vue?vue&type=template&id=0a062b6d"
import script from "./mailMessagingInput.vue?vue&type=script&lang=ts"
export * from "./mailMessagingInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports